module.exports = __webpack_public_path__ + "img/Haircut services.svg";